import wpdmIcons from "../../libs/icons";
import LinkTemplates from "../../libs/link-templates";
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
const {registerBlockType} = wp.blocks;
const {InspectorControls} = wp.editor;
const {TextControl, SelectControl, ServerSideRender, Modal, Button, PanelBody} = wp.components;

const { __ } = wp.i18n;

registerBlockType('download-manager/package', {
    title: 'Package',

    description: 'Download Manager Package',

    keywords: [
        __( 'download manager digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'package link' ),
    ],

    icon: wpdmIcons.downloadIcon(),

    category: 'wpdm-blocks',

    attributes: {
        packageID: {
            type: 'integer',
            default: 0
        },
        packageTitle: {
            type: 'string',
            default: 'Select Package'
        },
        template: {
            type: 'string',
            default: 'link-template-panel'
        }
    },

    edit({attributes, className, setAttributes}) {

        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }


        function onSelectPackage(_package) {
            setAttributes({ packageID: _package.value, packageTitle: _package.label });
        }

        function selectedPackage() {
            console.log(attributes);
            return {value: attributes.packageID, label: attributes.packageTitle};
        }


        const promiseOptions = inputValue => {
            return wp.apiFetch({path: `/wpdm/v2/search-package${inputValue ? '?selected='+attributes.packageID+'&s=' + inputValue : '?selected='+attributes.packageID}`})
                .then(response => response) // my option list array?
                .catch(err => {
                    console.log('some error', err);
                });
        };

        return [

            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                        <div className={"form-group"}>
                            <label>Select Package</label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={promiseOptions}
                                defaultOptions={[selectedPackage()]}
                                defaultValue={[selectedPackage()]}
                                onChange={onSelectPackage}
                            />
                        </div>
                        <LinkTemplates
                            label = {"Link Template:"}
                            value = {attributes.template}
                            onChange = {onChangeTemplate}
                        />
                    </PanelBody>
                </div>
            </InspectorControls>
            ,
            <ServerSideRender
                block={"download-manager/package"}
                attributes = {attributes}
            />
        ];
    },
    save() {
        return null;
    }
});
